import React from 'react'

export const Loader = () => {
    return (
        <div className="grid grid-center" style={{width: '100%', height: '300px'}}>

            <span className="loader"></span>
        </div>
    )
}
